import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Slide,
    Stack,
    Typography,
  } from "@mui/material";
  import { TransitionProps } from "@mui/material/transitions";
  import React, { forwardRef } from "react";
  import SiDialog from "./SiDialog";
  import AquantCancelIcon from "../resources/images/aq-cancel.svg";
  import { useTranslation } from "react-i18next";
  import "./UpdateScopDialog.scss";
import Util from "../Util";
  
  type Props = {
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
    lastUpdateDate: Date;
    latestInject: Date;
  };
  
  const Transition = forwardRef((
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
  ) => <Slide direction="up" ref={ref} {...props} />);
  
  const UpdateScopDialog = (props: Props) => {
    const { open, onSubmit, onClose, lastUpdateDate, latestInject } = props;
    const { t } = useTranslation();
  
    return (
      <SiDialog open={open} onClose={onClose} isBackdropClick TransitionComponent={Transition}>
        <DialogTitle>
          <Stack className="DialogTitle">
            <Typography className="DialogTitleText">
                Are you sure?
            </Typography>
            <img
              src={AquantCancelIcon}
              onClick={onClose}
              alt="cancel icon"
              className="CancelIcon"
            />
          </Stack>
        </DialogTitle>
        <Divider/>
        <DialogContent classes={{ root: "DialogContent" }}>
          {lastUpdateDate ? <Typography className="DialogContentTitle">
            The data that is <span className="BoldText">currently available</span> on SCOP is from the {Util.formatShortDate(new Date(lastUpdateDate), true)}.
          </Typography> : null}
          {latestInject ? <Typography className="DialogContentTitle WithSpace">
            You are about to update SCOP from the last SI dashboard update, that was on the {Util.formatShortDate(new Date(latestInject), true)}
          </Typography> : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            disableRipple
            className="DialogActionBtn"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {onSubmit(); onClose();}}
            variant="contained"
            disableRipple
            className="DialogActionBtn DialogActionBtnContained"
          >
            Update Scop
          </Button>
        </DialogActions>
      </SiDialog>
    );
  };
  
  export default UpdateScopDialog;
  